var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8417 2.43333L15.7583 4.61667C17.175 5.24167 17.175 6.275 15.7583 6.9L10.8417 9.08333C10.2833 9.33333 9.36666 9.33333 8.80833 9.08333L3.89166 6.9C2.475 6.275 2.475 5.24167 3.89166 4.61667L8.80833 2.43333C9.36666 2.18333 10.2833 2.18333 10.8417 2.43333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.16667C2.5 9.86667 3.025 10.675 3.66667 10.9583L9.325 13.475C9.75833 13.6667 10.25 13.6667 10.675 13.475L16.3333 10.9583C16.975 10.675 17.5 9.86667 17.5 9.16667",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.3333C2.5 14.1083 2.95833 14.8083 3.66667 15.125L9.325 17.6417C9.75833 17.8333 10.25 17.8333 10.675 17.6417L16.3333 15.125C17.0417 14.8083 17.5 14.1083 17.5 13.3333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.f3f60611f83a8a2d479eca4833dab492.svg";
export { ForwardRef as ReactComponent };